
import * as bootstrap from 'bootstrap';
import Swiper from 'swiper/bundle';
import Helper from './helper';
import TomSelect from 'tom-select';

import 'swiper/css/bundle';

class HNAB {
    constructor() {
        this.init();
    }

    init() {
        this.courseTimeslotSelect();
    }

    /**
     * Initialise (or reinitialise) the TomSelect instance for the course timeslot field.
     * Listens for the Livewire `timeslots-updated` browser event to rebuild when
     * the parent component fetches a new set of timeslots.
     */
    courseTimeslotSelect() {
        const buildSelect = () => {
            const el = document.getElementById('course_timeslot_id');
            const wrapper = document.getElementById('course_timeslot_id_wrapper');
            const hidden = document.getElementById('course_timeslot_id_hidden');

            if (!el || !wrapper) {
                return;
            }

            // Destroy existing instance before rebuilding
            if (el.tomselect) {
                el.tomselect.destroy();
            }

            const timeslots = JSON.parse(wrapper.dataset.timeslots || '[]');
            const placeholder = wrapper.dataset.placeholder || 'Kies een trainingsblok';

            // Build flat options list from the structured timeslot data
            // Keep the `order` index so TomSelect preserves the backend sort
            const options = timeslots.map((t, i) => ({
                value:        String(t.value),
                dates:        t.dates,
                location:     t.location,
                availability: t.availability,
                order:        i,
            }));

            new TomSelect(el, {
                options,
                items:          [],
                valueField:     'value',
                labelField:     'value',
                searchField:    [],   // not searchable — list is small and structured
                placeholder,
                allowEmptyOption: true,
                create:         false,
                sortField:      [{ field: 'order', direction: 'asc' }],

                render: {
                    // Each option: all dates on separate lines + location + availability badge
                    option(data, escape) {
                        const dateLines = (data.dates || [])
                            .map(d => `<span class="ts-timeslot__date">${escape(d)}</span>`)
                            .join('');

                        const location = data.location
                            ? `<span class="ts-timeslot__location">${escape(data.location)}</span>`
                            : '';

                        const avail = data.availability
                            ? `<span class="ts-timeslot__availability">${escape(data.availability)}</span>`
                            : '';

                        return `<div class="ts-timeslot">
                                    <div class="ts-timeslot__dates">${dateLines}</div>
                                    <div class="ts-timeslot__meta">${location}${avail}</div>
                                </div>`;
                    },

                    // Selected item: show only the first date + optional location
                    item(data, escape) {
                        const firstDate = (data.dates || [])[0] || '';
                        const extra = (data.dates || []).length > 1
                            ? ` <span class="ts-timeslot__more">(+${data.dates.length - 1})</span>`
                            : '';
                        const location = data.location
                            ? ` — ${escape(data.location)}`
                            : '';

                        return `<span>${escape(firstDate)}${extra}${location}</span>`;
                    },

                    no_results() {
                        return '<div class="no-results">Geen trainingsblokken beschikbaar</div>';
                    }
                },

                onChange(value) {
                    // Keep Livewire's hidden input in sync
                    if (hidden) {
                        hidden.value = value;
                        hidden.dispatchEvent(new Event('input'));
                    }
                }
            });
        };

        // Initial build
        buildSelect();

        // Rebuild when Livewire updates the timeslots (fires from BookingForm::updateCourseDates)
        window.addEventListener('timeslots-updated', () => {
            // Small tick so Livewire has finished patching the data-timeslots attribute
            requestAnimationFrame(buildSelect);
        });
    }
}

window.addEventListener('load', () => new HNAB());
